
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../environment/Api';



export default function ProtectedRoute({ children }) {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const fetchProtectedData = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsAuthenticated(false);
                setIsLoading(false);
                return;
            }
            try {
                const response = await axios.post(apiUrl + '/protectedroute', null, {
                    headers: {
                        'x-access-token': token
                    }
                });

                console.log("token verify",response.data)

                if (response.data.status === 'success') {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                    localStorage.removeItem('token');
                }
                
            } catch (error) {
                setIsAuthenticated(false);
                localStorage.removeItem('token');
            } finally {
                setTimeout(() => {
                    setIsLoading(false);
                  }, 100); // Delay for 1 second
            }
        };


        fetchProtectedData();
    }, []);

    if (isLoading) {
        return <div>
             <div>
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      </div>
        </div>;
    }

    if (!isAuthenticated) {
        return <Navigate to={'/'} replace />;
    }

    return (
        <>
            {children}
        </>
    );
}
